// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, chatDetailsProfessional } from "../../Utils/Constants";
import { toast } from "react-toastify";

export const hitGetChatDetailsProfessionalApi = createAsyncThunk(
  "hitGetChatDetailsProfessionalApi",
  async (payload) => {
    try {
      const config = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          Authorization: `${localStorage.getItem("professionalToken")}`,
        },
        params: payload,
      };
      const url = ApiBaseUrl + chatDetailsProfessional;
      const response = await axios.get(url, config);
      return response.data;
    } catch (error) {
      toast.error(error.response.data.message);
      throw error.response.data;
    }
  }
);

const GetChatDetailsProfessionalSlice = createSlice({
  name: "getChatDetailsProfessionalReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearhitGetChatDetailsData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitGetChatDetailsProfessionalApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitGetChatDetailsProfessionalApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(hitGetChatDetailsProfessionalApi.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearhitGetChatDetailsData } = GetChatDetailsProfessionalSlice.actions;
export default GetChatDetailsProfessionalSlice.reducer;
